<th scope="row" class="material_names">{{materialName | translate }}</th>

<ng-container *ngFor="let cat of categorysList;  index as catInd">
  <td class="table_rows">

     <app-category-type *ngIf="materialFormGroup && materialFormGroup.get('categeyControls') " [category]="material.category[cat]"
      [categoryCtl]="materialFormGroup.get('categeyControls')['controls'][catInd]"></app-category-type>  

  </td>
</ng-container>
<td class="total_row">
  <app-label [materialFormGroup]="materialFormGroup" [category]="material.category"></app-label>
  {{getTotalGeneratedTons() | number:'1.1-1'}}

</td>
